<div class="product-elements">
    <div class="details-card mat-elevation-z1" *ngFor="let parent of detailsTree.$$children">
        <div class="details-card-header">{{parent.name}}</div>
        <div class="details-card-body">
            <ul>
                <li *ngFor="let el of parent.$$children">
                    <span class="details-label" *ngIf="el.name">{{el.name}}:</span> <span class="value" *ngIf="el.value">{{el.value}}</span>
                    <ul *ngIf="el.$$children && el.$$children.length > 0">
                        <li *ngFor="let el2 of el.$$children">
                            <span class="details-label" *ngIf="el2.name">{{el2.name}}:</span> <span class="value" *ngIf="el2.value">{{el2.value}}</span>
                            <ul *ngIf="el2.$$children && el2.$$children.length > 0">
                                <li *ngFor="let el3 of el2.$$children">
                                    <span class="details-label" *ngIf="el3.name">{{el3.name}}:</span> <span class="value" *ngIf="el3.value">{{el3.value}}</span>
                                    <ul *ngIf="el3.$$children && el3.$$children.length > 0">
                                        <li *ngFor="let el4 of el3.$$children">
                                            <span class="details-label" *ngIf="el4.name">{{el4.name}}:</span> <span class="value" *ngIf="el4.value">{{el4.value}}</span>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>
